var React = require('react');

function IconMapSettingsConstructionActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#30B4C0","d":"M19.961 8.418L33.5 32.4h-27L19.961 8.418zM20 30l.249-3.276-1.326-1.026-3.099-1.824L12.2 30h1.2l3.225-4.176L18.8 27.15V30H20zm1.761-13.701h-.012a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 .012-3zM13.748 21.3l9.231 5.4L21.2 30H29l-3-5.4-2.172 1.2-.636-.36-1.374-4.941h-.078c-1.29 0-2.37-.905-2.64-2.133l-3.255.816-.858 1.458-.639-.375-.6 1.035zm5.877 2.043l1.089-1.692 1.302 3.093-2.391-1.401zm-3.843-2.25l.819-.867 1.599-.201-1.188 1.791-1.23-.723z"}));
}

IconMapSettingsConstructionActive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsConstructionActive;

IconMapSettingsConstructionActive.default = IconMapSettingsConstructionActive;
